import { ActionTypes } from "clorian-frontend-components";

const { LANGUAGE_REQUEST, LANGUAGE_SUCCESS, LANGUAGE_FAILURE } = ActionTypes;

export default function languages(
  state = {
    isFetching: false,
    authenticated: false
  },
  action
) {

  switch (action.type) {
    case LANGUAGE_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case LANGUAGE_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        languageList: action.response,
      });
    case LANGUAGE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}